// jsaForm/v1/emergencyEquipment.actions.js

export const makeJsaV1EmergencyEquipmentActions = ({ bump, emitJsaPatch }) => ({
  updateFireExtinguisherType(jsaData, value, emitPatch) {
    jsaData.jsaEmergencyEquipment.updateFireExtinguisherType(value);
    if (emitPatch) {
      const patch = jsaData.jsaEmergencyEquipment.toPatch({ fireExtinguisherType: value }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateFireExtinguisherInspectionDate(jsaData, value, emitPatch) {
    jsaData.jsaEmergencyEquipment.updateFireExtinguisherInspectionDate(value);
    if (emitPatch) {
      // Use the formatted date from the model, not the raw Date object
      const formattedDate = jsaData.jsaEmergencyEquipment.fireExtinguisherInspectionDate;
      const patch = jsaData.jsaEmergencyEquipment.toPatch({ fireExtinguisherInspectionDate: formattedDate }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateFireHydrantLocation(jsaData, value, emitPatch) {
    jsaData.jsaEmergencyEquipment.updateFireHydrantLocation(value);
    if (emitPatch) {
      const patch = jsaData.jsaEmergencyEquipment.toPatch({ fireHydrantLocation: value }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateEmergencyEyewashShowerLocation(jsaData, value, emitPatch) {
    jsaData.jsaEmergencyEquipment.updateEmergencyEyewashShowerLocation(value);
    if (emitPatch) {
      const patch = jsaData.jsaEmergencyEquipment.toPatch({ emergencyEyewashShowerLocation: value }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateWindDirection(jsaData, value, emitPatch) {
    jsaData.jsaEmergencyEquipment.updateWindDirection(value);
    if (emitPatch) {
      const patch = jsaData.jsaEmergencyEquipment.toPatch({ windDirection: value }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
  updateOtherEmergencyEquipment(jsaData, value, emitPatch) {
    jsaData.jsaEmergencyEquipment.updateOtherEmergencyEquipment(value);
    if (emitPatch) {
      const patch = jsaData.jsaEmergencyEquipment.toPatch({ otherEmergencyEquipment: value }, jsaData.jsaBasicInfo.rowId);
      emitJsaPatch(patch, emitPatch);
    }
    bump();
  },
});
